import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { StoreService } from './store.service';
import { take, map } from 'rxjs/operators';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class RestaurantGuard implements CanActivate {
  constructor(
    private router: Router,
    private storeService: StoreService
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    return this.storeService.selected_restaurant$.pipe(
      take(1),
      map(restaurant => {
        const hasRestaurant = restaurant && restaurant._id;
        if (!hasRestaurant) {
          // Fallback: check sessionStorage in case page was refreshed
          const stored = sessionStorage.getItem('restaurant_data');
          if (stored) {
            return true;
          }
          this.router.navigate(['/restaurant/dashboard']);
          return false;
        }
        return true;
      })
    );
  }
}
